import classnames from "classnames";
import classes from "../../../styles/Resources.module.scss";
import Banner from "../../../components/common/Banner/Banner";
import BannerType from "../../../global/banner-type";
import { videos } from "../../../global/constant";
import { nanoid } from "nanoid";
import CascadingList from "../../../components/core/CascadingList/CascadingList";
import resources from "../../../assets/images/resources.png";
import video from "../../../assets/videos/video.mov";
import useIsMobile from "../../../components/hooks/useIsMobile";

const Videos = () => {
  const isMobile = useIsMobile({ breakpoint: 992 });
  return (
    <>
      <>
        <div className={classnames(classes.main_content)}>
          <div className={classnames(classes.bannerSection)}>
            <Banner
              type={BannerType.SINGLE_IMAGE_BANNER}
              title="Videos"
              description="Audio-visual medium for entertainment & educational purposes."
              image={resources}
              maxWidth={214}
              className={classes.containerWidth}
            />
          </div>
          <div
            style={{
              margin: isMobile ? "16px 0" : "16px",
              height: "320px",
              position: "relative",
              backgroundColor: "#F1F5F9",
            }}
          >
            <div
              style={{
                fontWeight: 600,
                fontSize: "1.125rem",
                color: "#0f172a",
              }}
              className="center"
            >
              Video Features Coming soon!
              <div
                style={{
                  fontSize: "0.75rem",
                  color: "#64748B",
                }}
              >
                Something really cool is coming.
              </div>
            </div>
          </div>
          {/* <div className={classes.contentSection}>
            <div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 10,
                  padding: isMobile ? "20px 20px 20px 0" : "20px",
                }}
              >
                <video controls={true} src={video} width="100%"></video>
                <div className={classes.videoheading}>{videos[0].title}</div>
                <div className={classes.videosubtext}>
                  <span>{videos[0].subText}</span> •{" "}
                  <span>{videos[0].hours}</span>
                </div>
              </div>
              <div
                className={classnames(classes.grid_box, classes.video_gird)}
                style={{ flex: 1 }}
              >
                {videos.map(video => {
                  return (
                    <Banner
                      type={BannerType.VIDEO_BANNER}
                      {...video}
                      key={nanoid()}
                      width={"100%"}
                      height={152}
                      buttonLabel="Download"
                    />
                  );
                })}
              </div>
            </div>
            <div>
              <CascadingList data={videos} title="CONTENTS" />
            </div>
          </div> */}
        </div>
      </>
    </>
  );
};
export default Videos;
